// BonBoZ: popup "Trang mất kết nối". Logic thuần, tách khỏi .vue để test.
// Nguồn: Zalo = additional_attributes.zalo_trang_thai (bridge đẩy, xem
// Bonboz::TrangKetNoi); Facebook/Meta = reauthorization_required của upstream.
import { emitter } from 'shared/helpers/mitt';

export const SU_KIEN_MAT_KET_NOI = 'bonboz:trang_mat_ket_noi';

/** Zalo: chỉ "connected" là ổn; chưa có trạng thái = không có tài khoản bridge = mất. */
export const matKetNoi = inbox => {
  if (inbox?.channel_type === 'Channel::Api') {
    return inbox.additional_attributes?.zalo_trang_thai !== 'connected';
  }
  return !!inbox?.reauthorization_required;
};

/** Trang mất kết nối trong lựa chọn. `ids` rỗng = tất cả. */
export const trangMatKetNoi = (inboxes = [], ids = []) => {
  const chon = new Set((ids ?? []).map(Number));
  return inboxes.filter(
    inbox => (!chon.size || chon.has(Number(inbox.id))) && matKetNoi(inbox)
  );
};

/** Lựa chọn sau "Bỏ qua và tiếp tục": bỏ trang mất kết nối. Rỗng = ẩn nút (rỗng là "tất cả"). */
export const idConKetNoi = (inboxes = [], ids = []) => {
  const mat = new Set(trangMatKetNoi(inboxes, ids).map(i => Number(i.id)));
  const goc = ids?.length ? ids.map(Number) : inboxes.map(i => Number(i.id));
  return goc.filter(id => !mat.has(id));
};

/** Inbox sau khi áp sự kiện realtime `bonboz.trang_ket_noi`. */
export const apTrangKetNoi = (inbox, { mat_ket_noi: mat, trang_thai: tt }) =>
  inbox.channel_type === 'Channel::Api'
    ? {
        ...inbox,
        additional_attributes: {
          ...inbox.additional_attributes,
          zalo_trang_thai: tt,
        },
      }
    : { ...inbox, reauthorization_required: mat };

/**
 * Handler ActionCable: cập nhật store rồi báo popup. Chỉ báo khi trang VỪA chuyển
 * sang mất kết nối — đã mất rồi mà đổi kiểu mất (reconnecting → expired) thì im.
 */
export const nhanTrangKetNoi = (store, data) => {
  const cu = store.getters['inboxes/getInbox'](data.inbox_id);
  if (!cu?.id) return;
  const moi = apTrangKetNoi(cu, data);
  store.commit('inboxes/EDIT_INBOXES', moi);
  if (!matKetNoi(cu) && matKetNoi(moi)) emitter.emit(SU_KIEN_MAT_KET_NOI, moi);
};

/** Chỗ đăng nhập lại: Zalo = trang super admin có iframe bridge (tab mới); còn lại = cài đặt hộp thư. */
export const choDangNhapLai = inbox =>
  inbox?.channel_type === 'Channel::Api'
    ? { url: '/super_admin/app_config?config=zalo' }
    : {
        route: { name: 'settings_inbox_show', params: { inboxId: inbox?.id } },
      };
